import React from "react";

function Corner({ pos }) {
    const cls = {
        tl: "top-[76px] left-4 sm:left-10 border-t border-l",
        tr: "top-[76px] right-4 sm:right-10 border-t border-r",
        bl: "bottom-10  left-4 sm:left-10 border-b border-l",
        br: "bottom-10  right-4 sm:right-10 border-b border-r",
    }[pos];
    return <div className={`absolute w-5 h-5 border-nova-cyan/15 ${cls}`} />;
}

export default function HeroHUD() {
    return (
        <div
            className="absolute inset-0 pointer-events-none select-none z-[12]"
            aria-hidden="true"
        >
            <Corner pos="tl" />
            <Corner pos="tr" />
            <Corner pos="bl" />
            <Corner pos="br" />
        </div>
    );
}
